"use client";
import { ComingSoon, PageContainer } from "@components";
import { getTransitions, LangProps } from "i18n";
// import {
//   faDiscord,
//   faGithub,
//   faTwitter,
// } from "@fortawesome/free-brands-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Button } from "@shadcn-ui/button";
import { FC, memo } from "react";

const FeedBack: FC<LangProps> = ({ params }) => {
  const t = getTransitions(params.lang);
  return (
    <PageContainer title={t("common.feedback")}>
      <ComingSoon />
      {/* <div className="flex items-center gap-2">
        <Button size="icon" variant="secondary">
          <FontAwesomeIcon icon={faTwitter} />
        </Button>
        <Button size="icon" variant="secondary">
          <FontAwesomeIcon icon={faGithub} />
        </Button>
        <Button size="icon" variant="secondary">
          <FontAwesomeIcon icon={faDiscord} />
        </Button>
      </div> */}
    </PageContainer>
  );
};

export default memo(FeedBack);
